// extracted by mini-css-extract-plugin
export default {"content":"Shapes_content__AdJCC","shapes":"Shapes_shapes__BCXVd","sh":"Shapes_sh__1g8V6"};